import { components } from "@/api-schema";
import { RELOCATION_ORDER_STATUS_FILTER_OPTIONS } from "@/components/filter/predefined/relocation-order-status-filter";
import { RowAction, RowActionVariant } from "@/components/ui/table-row-actions";
import { CalendarCheck } from "lucide-react";
import { RelocationOrderExternalActionsContext } from "./relocation-order-external-actions-context";

type RelocationOrder = components["schemas"]["RelocationOrder"];

export function buildExternalFlowActions(
  order: RelocationOrder,
  context: RelocationOrderExternalActionsContext,
): RowAction[] {
  if (order.status !== RELOCATION_ORDER_STATUS_FILTER_OPTIONS.Transport_Company_Awaiting_Pickup_Date.id) {
    return [];
  }

  return [
    {
      label: context.t("fit:SetPickupDate"),
      icon: <CalendarCheck className="h-4 w-4" />,
      variant: RowActionVariant.Success,
      onClick: () => context.navigateToSetPickupDateView(order),
    },
  ];
}
